import { render } from "./CourseMaterialsView.vue?vue&type=template&id=46daf058"
import script from "./CourseMaterialsView.vue?vue&type=script&lang=js"
export * from "./CourseMaterialsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__